import { NavigateOptions } from 'react-router';
import { useSearchParams } from 'react-router-dom';

/**
 * @example
 * const [page, setPage] = useQuerySearchParams<number>(Parameters.page);
 */
export const useQuerySearchParams = <T>(
  key: string,
): [T | undefined, (newQuery: T | undefined, options?: NavigateOptions) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramValue = searchParams.get(key);

  const value = paramValue ? JSON.parse(paramValue) : undefined;

  const setValue = (newValue: T | undefined, options?: NavigateOptions) => {
    let newSearchParams = new URLSearchParams(searchParams);

    if (newValue !== undefined) {
      newSearchParams.set(key, JSON.stringify(newValue));
    } else {
      newSearchParams.delete(key);
    }

    setSearchParams(newSearchParams, options);
  };

  return [value, setValue];
};
